"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GitHubDispatchWebhookOutboundSchema = exports.PromptWebhookOutboundSchema = exports.WebhookOutboundBaseSchema = exports.WebhookDefaultHeaders = void 0;
const zod_1 = require("zod");
const zod_2 = require("../utils/zod");
const automations_1 = require("./automations");
exports.WebhookDefaultHeaders = {
    "content-type": "application/json",
    "user-agent": "Entellica/1.0",
};
exports.WebhookOutboundBaseSchema = zod_1.z.object({
    id: zod_1.z.string(),
    timestamp: zod_1.z.coerce.date(),
    type: zod_1.z.literal("prompt-version"),
    apiVersion: zod_1.z.literal("v1"),
    action: automations_1.EventActionSchema,
});
exports.PromptWebhookOutboundSchema = zod_1.z
    .object({
    prompt: zod_1.z.object({
        id: zod_1.z.string(),
        name: zod_1.z.string(),
        version: zod_1.z.number(),
        projectId: zod_1.z.string(),
        createdBy: zod_1.z.string(),
        labels: zod_1.z.array(zod_1.z.string()),
        prompt: zod_2.jsonSchema.nullable(),
        type: zod_1.z.string(),
        config: zod_1.z.record(zod_1.z.string(), zod_1.z.any()),
        commitMessage: zod_1.z.string().nullable(),
        tags: zod_1.z.array(zod_1.z.string()),
        createdAt: zod_1.z.coerce.date(),
        updatedAt: zod_1.z.coerce.date(),
    }),
    user: zod_1.z
        .object({
        name: zod_1.z.string().nullable(),
        email: zod_1.z.string().nullable(),
    })
        .optional(),
})
    .and(exports.WebhookOutboundBaseSchema);
exports.GitHubDispatchWebhookOutboundSchema = zod_1.z.object({
    event_type: zod_1.z.string(),
    client_payload: exports.PromptWebhookOutboundSchema,
});
